import React, { useState, useEffect } from 'react';
import Router, { withRouter } from 'next/router';
import SiteLayout from '../SiteLayout/SiteLayout';
import Toggle from '../../components/Toggle/Toggle';
import Social from '../../components/Social/Social';

import trackEvent from '../../utils/event-helper';
import { useStateValue, setLoading } from '../../state/stateProvider';

const options = [
  { label: 'Login', authPath: 'login' }, { label: 'register', authPath: 'signup' },
];

const AuthLayout = ({ children, router }) => {
  const [{ user }, dispatch] = useStateValue();

  const [selectedScreen, setSelectedScreen] = useState<number>(router.pathname.includes('signup') ? 1 : 0);

  useEffect(() => {
    if (!user) {
      return;
    }
    if (user === 'error') {
      trackEvent('signin_loaded');
      setLoading(dispatch, false);
    } else {
      Router.push({
        pathname: user?.TOTPClient.active ? '/auth/mfa/mfa-login' : '/',
        query: router.query,
      });
    }
  }, [user]);

  useEffect(() => {
    setSelectedScreen(router.pathname.includes('signup') ? 1 : 0);
  }, [router]);

  const toggleScreen = (newScreen) => {
    setSelectedScreen(newScreen);
    const screenPath = options[newScreen].authPath;
    const urlParams = new URLSearchParams(window?.location.search);
    router.push(`/auth/${screenPath}?${urlParams}`);
  };

  // Show only Login option on login page, both options on signup page
  const isSignupPage = router.pathname.includes('signup');
  const displayOptions = isSignupPage ? options : [options[0]];

  return (
    <SiteLayout className={`authFrame authGeneral ${selectedScreen ? 'right' : 'left'}`}>
      {/* Linkdin attribution bellow */}
      <img height="1" width="1" style={{ display: 'none' }} alt=''
         src='https://px.ads.linkedin.com/collect/?pid=431617&conversionId=3826617&fmt=gif' />
      <Toggle className="authToggle" selected={selectedScreen} options={displayOptions} onClick={toggleScreen}/>
      <div style={{ gridRow: 4 }} className="authLayout">{children}</div>
      <Social style={{ gridRow: 6 }}/>
    </SiteLayout>
  );
};

export default withRouter(AuthLayout);
